/* build:1779224789 */
/* ChillNeck Theme JS — vanilla */
(function(){
  'use strict';

  // Generisches form_submit-Tracking + eigene Validierung für alle Mailchimp-Formulare (Footer, Newsletter-Streifen).
  // Popups (newsletter-popup, exit-intent-popup) tracken sich selbst inline, da sie eigene
  // form_open/form_close-States haben, die dieses generische Snippet nicht kennt.
  // novalidate + eigene Fehlermeldung, weil die native Browser-Bubble immer in der Sprache des
  // Browsers/Betriebssystems erscheint, nicht in der Seitensprache.
  document.querySelectorAll('[data-mc-form]').forEach(function (form) {
    form.noValidate = true;
    var errorEl = form.querySelector('[data-form-error]');
    var emailInput = form.querySelector('input[type="email"]');
    var consentInput = form.querySelector('input[type="checkbox"]');
    var V = (window.cnT && window.cnT.validation) || {};
    form.addEventListener('submit', function (e) {
      if (errorEl) errorEl.hidden = true;
      if (emailInput && !emailInput.checkValidity()) {
        e.preventDefault();
        if (errorEl) { errorEl.textContent = V.emailInvalid || 'Please enter a valid email address.'; errorEl.hidden = false; }
        emailInput.focus();
        return;
      }
      if (consentInput && !consentInput.checked) {
        e.preventDefault();
        if (errorEl) { errorEl.textContent = V.consentRequired || 'Please confirm the newsletter sign-up.'; errorEl.hidden = false; }
        consentInput.focus();
        return;
      }
      var name = form.getAttribute('data-form-name') || 'newsletter';
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'form_submit', form_name: name });
        window.dataLayer.push({ event: 'generate_lead' });
      } catch (err) {}
    });
  });

  // GA4 form_start (Enhanced-Measurement-Standard) — feuert EINMAL pro Sitzung, site-weit, bei der
  // ersten echten Interaktion mit irgendeinem Formular. Bewusst getrennt von unserem form_open/
  // form_close (die messen Popup-Sichtbarkeit/Abbruch pro Modal, nicht Formular-Interaktion — kein
  // GA4-Standard-Äquivalent dafür, daher als eigene Events belassen statt umzubenennen).
  (function () {
    var FS_KEY = 'cn_form_start_fired';
    try { if (sessionStorage.getItem(FS_KEY) === '1') return; } catch (e) {}
    function onFocusIn(e) {
      var form = e.target && e.target.closest && e.target.closest('form');
      if (!form) return;
      // Nur BENANNTE Formulare tracken — sonst entsteht form_start mit form_name "(not set)".
      // Reihenfolge: unser data-form-name → name-Attribut → DOM-id. Ohne Namen: NICHT feuern,
      // Listener bleibt aktiv und wartet auf das nächste benannte Formular in dieser Sitzung.
      var fsName = form.getAttribute('data-form-name') || form.getAttribute('name') || form.id || '';
      if (!fsName) return;
      try {
        if (sessionStorage.getItem(FS_KEY) === '1') { document.removeEventListener('focusin', onFocusIn, true); return; }
        sessionStorage.setItem(FS_KEY, '1');
      } catch (err) {}
      window.dataLayer = window.dataLayer || [];
      var fsPayload = { event: 'form_start', form_name: fsName };
      if (form.id) fsPayload.form_id = form.id;
      if (form.action) fsPayload.form_destination = form.action;
      window.dataLayer.push(fsPayload);
      document.removeEventListener('focusin', onFocusIn, true);
    }
    document.addEventListener('focusin', onFocusIn, true);
  })();

  // Cart-Drawer toggle (only attach if drawer exists in DOM)
  if (document.querySelector('.cn-cart-drawer')) {
    document.addEventListener('click', function(e){
      var trigger = e.target.closest('[data-cart-open]');
      if (trigger) {
        e.preventDefault();
        document.querySelector('.cn-cart-drawer').classList.add('is-open');
      }
      if (e.target.closest('[data-cart-close]') || e.target.classList.contains('cn-cart-drawer__overlay')) {
        document.querySelector('.cn-cart-drawer').classList.remove('is-open');
      }
    });
  }

  // FAQ accordion
  document.addEventListener('click', function(e){
    var q = e.target.closest('[data-faq-q]');
    if (q) {
      var item = q.closest('[data-faq-item]');
      if (item) item.classList.toggle('is-open');
    }
  });

  // FAQ-Klicks tracken (Tim, 20.08.2026): toggle statt click, damit auch das
  // Aufklappen per Tastatur erfasst wird. toggle bubbelt nicht, deshalb
  // Capture-Phase auf document. Nur beim OEFFNEN gemeldet, nicht beim
  // Schliessen, sonst doppelt so viele Events fuer dieselbe Frage. Deckt
  // reguläre FAQ-Sections (.cn-faq__item) und die aus Blogartikeln automatisch
  // erzeugten FAQ-Bloecke (.cn-article-faq details) ab. Bewusst NICHT generisch
  // auf jedes <details>: das <details> im Kundenkonto (Adress-Formular) ist
  // keine FAQ und soll hier nicht mitgezaehlt werden.
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!details.matches || !details.matches('.cn-faq__item, .cn-article-faq details')) return;
    if (!details.open) return;
    var summary = details.querySelector('summary');
    if (!summary) return;
    var span = summary.querySelector('span');
    var question = (span ? span.textContent : summary.textContent || '').trim();
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'faq_expand', faq_question: question });
    } catch (err) {}
  }, true);

  // Canonicalize-Helpers — T&A übersetzt manche option-values (z.B. 'woman'→'mujer'),
  // diese Maps fangen alle bekannten Locale-Varianten ab.
  function canonicalKey(k) {
    if (!k) return k;
    var v = String(k).toLowerCase().trim();
    if (['gender','género','genero','geschlecht'].indexOf(v) >= 0) return 'gender';
    if (['neck','cuello','hals','halsumfang'].indexOf(v) >= 0) return 'neck';
    if (['fit','en forma','passform','sitz','enforma'].indexOf(v) >= 0) return 'fit';
    return v;
  }
  function canonicalAnswer(v) {
    if (!v) return v;
    var s = String(v).toLowerCase().trim();
    // Gender
    if (['woman','mujer','frau','femme','donna'].indexOf(s) >= 0) return 'woman';
    if (['man','hombre','mann','homme','uomo'].indexOf(s) >= 0) return 'man';
    if (['diverse','diverso','divers'].indexOf(s) >= 0) return 'diverse';
    if (['unspecified','sin especificar','sinespecificar','keine angabe','keineangabe','non specificato'].indexOf(s) >= 0) return 'unspecified';
    // Fit
    if (['tight','ajustado','eng anliegend','enganliegend','engantliegend','aderente','serré'].indexOf(s) >= 0) return 'tight';
    if (['loose','holgado','lockerer sitz','lockerersitz','locker','largo','ample'].indexOf(s) >= 0) return 'loose';
    // Neck values (under_32, 32_34, etc.) sind locale-stabil — pass-through
    return s;
  }

  // Helper: compute recommended {size, color} from answer set
  function computeRecommendation(answers) {
    var gender = answers.gender || 'unspecified';
    var neck = answers.neck || 'unsure';
    var fit = answers.fit || 'tight';
    var color = (gender === 'woman' || gender === 'diverse') ? 'pink' : 'mint';
    var size;
    if (neck === 'under_32') size = 'S';
    else if (neck === '32_34') size = (fit === 'loose') ? 'M' : 'S';
    else if (neck === '34_40') size = 'M';
    else if (neck === '40_42') size = (fit === 'loose') ? 'L' : 'M';
    else if (neck === 'over_42') size = 'L';
    else /* unsure */ size = (fit === 'loose') ? 'L' : 'M';
    return { size: size, color: color };
  }

  function sizeBlurb(size) {
    var T = (window.cnT && window.cnT.sizeFinder) || {};
    if (size === 'S') return T.blurbS || 'Klein und unauffällig — perfekt für schmalere Hälse oder Kinder.';
    if (size === 'L') return T.blurbL || 'Großzügiger Sitz — perfekt für kräftigere Hälse oder einen entspannten Look.';
    return T.blurbM || 'Unsere meistverkaufte Größe — passt 7 von 10 Erwachsenen.';
  }

  function colorLabel(color) {
    var T = (window.cnT && window.cnT.sizeFinder) || {};
    return color === 'pink' ? (T.colorPink || 'Pink Frost') : (T.colorMint || 'Arctic Mint');
  }

  function ctaLabel(color, size) {
    var T = (window.cnT && window.cnT.sizeFinder) || {};
    var price = (typeof window.cnSalePrice !== 'undefined') ? window.cnSalePrice : '';
    var tpl = T.ctaHtml || 'Sichern: __COLOR__ in __SIZE__ — €__PRICE__';
    return tpl.replace('__COLOR__', colorLabel(color)).replace('__SIZE__', size).replace('__PRICE__', String(price));
  }

  function combinedLabel(color, size) {
    var T = (window.cnT && window.cnT.sizeFinder) || {};
    var tpl = T.combinedHtml || '<strong>__COLOR__</strong> — Größe <strong>__SIZE__</strong>';
    return tpl.replace('__COLOR__', colorLabel(color)).replace('__SIZE__', size);
  }

  // Quiz state — page-level (sizing-quiz.liquid section)
  var quiz = document.querySelector('[data-quiz]');
  if (quiz) {
    var qSteps = quiz.querySelectorAll('[data-quiz-step]');
    var qAnswers = {};
    var quizPink = quiz.getAttribute('data-product-pink');
    var quizMint = quiz.getAttribute('data-product-mint');
    var quizPrice = quiz.getAttribute('data-sale-price') || '';
    window.cnSalePrice = quizPrice;

    // Seiten-eingebettetes Quiz (kein Modal) — form_open/close via Sichtbarkeit statt Öffnen/Schließen.
    var qOpened = false;
    var qCompleted = false;
    function qPushDl(payload) {
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch (err) {}
    }
    if ('IntersectionObserver' in window) {
      var qObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !qOpened) {
            qOpened = true;
            qPushDl({ event: 'form_open', form_name: 'size_finder_page' });
            qObserver.disconnect();
          }
        });
      }, { threshold: 0.3 });
      qObserver.observe(quiz);
    }
    window.addEventListener('pagehide', function () {
      if (qOpened && !qCompleted) qPushDl({ event: 'form_close', form_name: 'size_finder_page' });
    });

    quiz.addEventListener('click', function(e){
      var btn = e.target.closest('[data-quiz-answer]');
      if (!btn) return;
      var step = btn.closest('[data-quiz-step]');
      var key = canonicalKey(step.getAttribute('data-quiz-step'));
      qAnswers[key] = canonicalAnswer(btn.getAttribute('data-quiz-answer'));
      var idx = parseInt(step.getAttribute('data-idx'), 10);
      qSteps.forEach(function(s){ s.classList.remove('is-active'); });
      var next = quiz.querySelector('[data-idx="'+(idx+1)+'"]');
      if (next) next.classList.add('is-active');
      else {
        var rec = computeRecommendation(qAnswers);
        var result = quiz.querySelector('[data-quiz-result]');
        if (result) {
          var sizeEl = result.querySelector('[data-quiz-size]');
          var combinedEl = result.querySelector('[data-quiz-combined]');
          var blurbEl = result.querySelector('[data-quiz-blurb]');
          var ctaEl = result.querySelector('[data-quiz-cta]');
          if (sizeEl) {
            sizeEl.textContent = rec.size;
            sizeEl.classList.toggle('is-mint', rec.color === 'mint');
          }
          if (combinedEl) combinedEl.innerHTML = combinedLabel(rec.color, rec.size);
          if (blurbEl) blurbEl.textContent = sizeBlurb(rec.size);
          if (ctaEl) {
            var quizUrl = rec.color === 'mint' ? quizMint : quizPink;
            quizUrl += (quizUrl.indexOf('?') >= 0 ? '&' : '?') + 'cn_size=' + rec.size;
            ctaEl.setAttribute('href', quizUrl);
            ctaEl.textContent = ctaLabel(rec.color, rec.size);
          }
          result.classList.add('is-active');
          result.classList.toggle('is-mint', rec.color === 'mint');
          qCompleted = true;
          var qSub = { event: 'form_submit', form_name: 'size_finder_page', recommended_color: rec.color, recommended_size: rec.size };
          if (qAnswers.gender) qSub.answer_gender = qAnswers.gender;
          if (qAnswers.neck) qSub.answer_neck = qAnswers.neck;
          if (qAnswers.fit) qSub.answer_fit = qAnswers.fit;
          qPushDl(qSub);
        }
      }
    });
  }

  // Size-Finder Modal (global)
  var sfModal = document.getElementById('cn-sf-modal');
  if (sfModal) {
    var sfSteps = sfModal.querySelectorAll('[data-sf-step]');
    var sfResult = sfModal.querySelector('[data-sf-result]');
    var sfAnswers = {};
    var sfPink = sfModal.getAttribute('data-product-pink');
    var sfMint = sfModal.getAttribute('data-product-mint');
    var sfPrice = sfModal.getAttribute('data-sale-price') || '';
    window.cnSalePrice = window.cnSalePrice || sfPrice;

    var sfCompleted = false;
    function sfPushDl(payload) {
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch (err) {}
    }
    function sfReset() {
      sfAnswers = {};
      sfCompleted = false;
      sfSteps.forEach(function(s, i){ s.classList.toggle('is-active', i === 0); });
      sfResult.classList.remove('is-active');
      sfResult.classList.remove('is-mint');
    }

    function sfOpen() {
      sfReset();
      sfModal.removeAttribute('hidden');
      document.body.classList.add('cn-sf-open');
      sfModal.querySelector('.cn-sf-modal__close').focus();
      sfPushDl({ event: 'form_open', form_name: 'size_finder' });
    }
    function sfClose() {
      sfModal.setAttribute('hidden', '');
      document.body.classList.remove('cn-sf-open');
      if (!sfCompleted) sfPushDl({ event: 'form_close', form_name: 'size_finder' });
    }
    window.openSizeFinder = sfOpen;
    window.closeSizeFinder = sfClose;

    document.addEventListener('click', function(e){
      if (e.target.closest('[data-open-size-finder]')) {
        e.preventDefault();
        sfOpen();
      }
      if (e.target.closest('[data-close-size-finder]')) {
        sfClose();
      }
    });

    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && !sfModal.hasAttribute('hidden')) sfClose();
    });

    sfModal.addEventListener('click', function(e){
      var btn = e.target.closest('[data-sf-answer]');
      if (btn) {
        var step = btn.closest('[data-sf-step]');
        var key = canonicalKey(step.getAttribute('data-sf-step'));
        sfAnswers[key] = canonicalAnswer(btn.getAttribute('data-sf-answer'));
        var idx = parseInt(step.getAttribute('data-idx'), 10);
        sfSteps.forEach(function(s){ s.classList.remove('is-active'); });
        var next = sfModal.querySelector('[data-sf-step][data-idx="'+(idx+1)+'"]');
        if (next) {
          next.classList.add('is-active');
        } else {
          var rec = computeRecommendation(sfAnswers);
          var sizeEl = sfResult.querySelector('[data-sf-size]');
          var combinedEl = sfResult.querySelector('[data-sf-combined]');
          var blurbEl = sfResult.querySelector('[data-sf-blurb]');
          var ctaEl = sfResult.querySelector('[data-sf-cta]');
          if (sizeEl) {
            sizeEl.textContent = rec.size;
            sizeEl.classList.toggle('is-mint', rec.color === 'mint');
          }
          if (combinedEl) combinedEl.innerHTML = combinedLabel(rec.color, rec.size);
          if (blurbEl) blurbEl.textContent = sizeBlurb(rec.size);
          if (ctaEl) {
            var sfUrl = rec.color === 'mint' ? sfMint : sfPink;
            sfUrl += (sfUrl.indexOf('?') >= 0 ? '&' : '?') + 'cn_size=' + rec.size;
            ctaEl.setAttribute('href', sfUrl);
            ctaEl.textContent = ctaLabel(rec.color, rec.size);
          }
          sfResult.classList.add('is-active');
          sfResult.classList.toggle('is-mint', rec.color === 'mint');
          sfCompleted = true;
          var sfSub = { event: 'form_submit', form_name: 'size_finder', recommended_color: rec.color, recommended_size: rec.size };
          if (sfAnswers.gender) sfSub.answer_gender = sfAnswers.gender;
          if (sfAnswers.neck) sfSub.answer_neck = sfAnswers.neck;
          if (sfAnswers.fit) sfSub.answer_fit = sfAnswers.fit;
          sfPushDl(sfSub);
        }
        return;
      }
      if (e.target.closest('[data-sf-restart]')) {
        sfReset();
      }
    });
  }

  // Reviews filter
  var reviews = document.querySelector('[data-reviews]');
  if (reviews) {
    reviews.addEventListener('click', function(e){
      var f = e.target.closest('[data-review-filter]');
      if (!f) return;
      var tag = f.getAttribute('data-review-filter');
      reviews.querySelectorAll('[data-review-filter]').forEach(function(b){ b.classList.remove('is-active'); });
      f.classList.add('is-active');
      reviews.querySelectorAll('[data-review-card]').forEach(function(card){
        if (tag === 'all' || card.getAttribute('data-review-tag') === tag) card.style.display = '';
        else card.style.display = 'none';
      });
    });
  }

  // Bundle Configurator Modal
  var bcModal = document.getElementById('cn-bc-modal');
  var bcDataEl = document.getElementById('cn-bc-data');
  if (bcModal && bcDataEl) {
    var bcData = JSON.parse(bcDataEl.textContent);
    var bcRingsEl = bcModal.querySelector('[data-bc-rings]');
    var bcTotalEl = bcModal.querySelector('[data-bc-total]');
    var bcSavingsEl = bcModal.querySelector('[data-bc-savings]');
    var bcSubmit = bcModal.querySelector('[data-bc-submit]');
    var bcSubmitLabel = bcModal.querySelector('[data-bc-submit-label]');
    var bcEyebrow = bcModal.querySelector('[data-bc-eyebrow]');
    var bcSub = bcModal.querySelector('[data-bc-sub]');
    var currentQty = 1;
    var currentRings = []; // [{ productHandle, size }]
    var bcCompleted = false;

    function bcFindVariant(productHandle, size) {
      var p = bcData.products.find(function(x){ return x.handle === productHandle; });
      if (!p) return null;
      return p.variants.find(function(v){ return v.size === size; }) || null;
    }
    function bcFindProduct(handle) {
      return bcData.products.find(function(x){ return x.handle === handle; }) || null;
    }
    function bcRenderRings(qty) {
      var T = (window.cnT && window.cnT.bundle) || {};
      bcRingsEl.innerHTML = '';
      currentRings = [];
      for (var i = 0; i < qty; i++) {
        currentRings.push({ productHandle: null, size: null });
        var ring = document.createElement('div');
        ring.className = 'cn-bc-ring';
        ring.dataset.bcRing = String(i);
        var ringPos = (T.ringPosition || 'Ring __POS__ / __TOTAL__')
          .replace('__POS__', String(i + 1))
          .replace('__TOTAL__', String(qty));
        var colorLabel = T.colorLabel || 'Farbe';
        var sizeLabel = T.sizeLabel || 'Größe';
        ring.innerHTML =
          '<div class="cn-bc-ring__head">' +
            '<span class="cn-bc-ring__num">' + ringPos + '</span>' +
            '<span class="cn-bc-ring__preview" data-bc-preview></span>' +
          '</div>' +
          '<div class="cn-bc-row">' +
            '<div class="cn-bc-field">' +
              '<label>' + colorLabel + '</label>' +
              '<div class="cn-bc-pills" data-bc-color>' +
                bcData.products.map(function(p){
                  return '<button type="button" class="cn-bc-pill" data-color="'+p.tone+'" data-product="'+p.handle+'">'+p.title+'</button>';
                }).join('') +
              '</div>' +
            '</div>' +
            '<div class="cn-bc-field">' +
              '<label>' + sizeLabel + '</label>' +
              '<div class="cn-bc-pills" data-bc-size>' +
                ['S','M','L'].map(function(s){
                  return '<button type="button" class="cn-bc-pill" data-size="'+s+'">'+s+'</button>';
                }).join('') +
              '</div>' +
            '</div>' +
          '</div>';
        bcRingsEl.appendChild(ring);
      }
      bcUpdateTotals();
    }
    function bcUpdateRingPreview(ringIdx) {
      var ringEl = bcRingsEl.querySelector('[data-bc-ring="'+ringIdx+'"]');
      if (!ringEl) return;
      var preview = ringEl.querySelector('[data-bc-preview]');
      var ring = currentRings[ringIdx];
      if (ring && ring.productHandle) {
        var p = bcFindProduct(ring.productHandle);
        if (p) preview.style.background = 'linear-gradient(135deg, #fff, ' + p.color + ')';
      }
    }
    function bcUpdateTotals() {
      var subtotal = 0;
      var allSelected = true;
      for (var i = 0; i < currentRings.length; i++) {
        var r = currentRings[i];
        if (r.productHandle && r.size) {
          var v = bcFindVariant(r.productHandle, r.size);
          if (v) subtotal += v.price;
        } else {
          allSelected = false;
        }
      }
      // apply tier discount (per-item)
      var tier = bcData.tiers.slice().reverse().find(function(t){ return currentRings.length >= t.minQty; });
      var perItemOff = tier ? (tier.perItemOff || 0) : 0;
      var totalOff = perItemOff * currentRings.length;
      var total = Math.max(0, subtotal - totalOff);
      bcTotalEl.textContent = '€' + (total / 100).toFixed(2).replace('.', ',');
      var T = (window.cnT && window.cnT.bundle) || {};
      var savingsTpl = T.youSave || 'Du sparst €__AMT__ (__TIER__)';
      bcSavingsEl.textContent = totalOff > 0
        ? savingsTpl
            .replace('__AMT__', (totalOff / 100).toFixed(0))
            .replace('__TIER__', tier.label)
        : '';
      bcSubmit.disabled = !allSelected;
    }
    function bcOpen(qty) {
      currentQty = qty;
      var T = (window.cnT && window.cnT.bundle) || {};
      var eyebrowMap = {
        1: T.eyebrowSolo || 'Solo konfigurieren',
        2: T.eyebrowDuo  || 'Duo konfigurieren',
        4: T.eyebrowCrew || 'Crew konfigurieren'
      };
      bcEyebrow.textContent = eyebrowMap[qty] || (T.eyebrowDefault || 'Bundle konfigurieren');
      bcModal.querySelector('[data-bc-title]').textContent = qty === 1
        ? (T.titleSolo || 'Wähle Farbe & Größe.')
        : (T.titleMulti || 'Wähle Farbe & Größe pro Ring.');
      bcSub.textContent = qty > 1
        ? (T.subMulti || 'Mengenrabatt wird automatisch im Warenkorb angewendet.')
        : (T.subSolo || 'Direkt in den Warenkorb.');
      if (qty === 1) {
        bcSubmitLabel.textContent = T.submitSolo || 'In den Warenkorb';
      } else {
        var multiTpl = T.submitMulti || '__QTY__× in den Warenkorb';
        bcSubmitLabel.textContent = multiTpl.replace('__QTY__', String(qty));
      }
      bcRenderRings(qty);
      bcModal.removeAttribute('hidden');
      document.body.classList.add('cn-bc-open');
      bcCompleted = false;
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'form_open', form_name: 'bundle_configurator' }); } catch (err) {}
    }
    function bcClose() {
      bcModal.setAttribute('hidden', '');
      document.body.classList.remove('cn-bc-open');
      if (!bcCompleted) {
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'form_close', form_name: 'bundle_configurator' }); } catch (err) {}
      }
    }
    window.openBundleConfig = bcOpen;
    window.closeBundleConfig = bcClose;

    document.addEventListener('click', function(e){
      var trigger = e.target.closest('[data-open-bundle-config]');
      if (trigger) {
        e.preventDefault();
        var qty = parseInt(trigger.getAttribute('data-open-bundle-config'), 10) || 1;
        bcOpen(qty);
      }
      if (e.target.closest('[data-close-bundle-config]')) {
        bcClose();
      }
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && !bcModal.hasAttribute('hidden')) bcClose();
    });

    bcModal.addEventListener('click', function(e){
      var pill = e.target.closest('.cn-bc-pill');
      if (!pill) return;
      var ringEl = pill.closest('[data-bc-ring]');
      if (!ringEl) return;
      var idx = parseInt(ringEl.getAttribute('data-bc-ring'), 10);
      var group = pill.parentElement;
      // toggle within group
      group.querySelectorAll('.cn-bc-pill').forEach(function(p){ p.setAttribute('aria-pressed', 'false'); });
      pill.setAttribute('aria-pressed', 'true');
      if (pill.hasAttribute('data-product')) {
        currentRings[idx].productHandle = pill.getAttribute('data-product');
      } else if (pill.hasAttribute('data-size')) {
        currentRings[idx].size = pill.getAttribute('data-size');
      }
      bcUpdateRingPreview(idx);
      bcUpdateTotals();
    });

    bcSubmit.addEventListener('click', async function(){
      if (bcSubmit.disabled) return;
      bcSubmit.classList.add('is-loading');
      bcSubmit.disabled = true;
      var Tsub = (window.cnT && window.cnT.bundle) || {};
      bcSubmitLabel.textContent = Tsub.submitting || 'Wird hinzugefügt …';

      // Aggregate by variant_id
      var byVariant = {};
      currentRings.forEach(function(r){
        var v = bcFindVariant(r.productHandle, r.size);
        if (!v) return;
        byVariant[v.id] = (byVariant[v.id] || 0) + 1;
      });
      var items = Object.keys(byVariant).map(function(id){
        return { id: parseInt(id, 10), quantity: byVariant[id] };
      });

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items }),
        });
        if (!res.ok) throw new Error('cart/add failed: ' + res.status);
        bcCompleted = true;

        // GA4 add_to_cart push — Page-Reload kommt direkt danach, GTM-Tags
        // werden via sendBeacon abgesetzt, daher synchroner push reicht.
        try {
          var tierForEvent = bcData.tiers.slice().reverse().find(function(t){ return currentRings.length >= t.minQty; }) || { perItemOff: 0 };
          var perItemOff = tierForEvent.perItemOff || 0;
          var trackingItems = [];
          var totalValue = 0;
          Object.keys(byVariant).forEach(function(vid){
            var qty = byVariant[vid];
            // Variant + Product zurücksuchen
            var foundV = null, foundP = null;
            for (var i = 0; i < bcData.products.length; i++) {
              var p = bcData.products[i];
              var vv = p.variants.find(function(x){ return String(x.id) === String(vid); });
              if (vv) { foundV = vv; foundP = p; break; }
            }
            if (!foundV) return;
            var unitCents = Math.max(0, (foundV.price || 0) - perItemOff);
            var unit = unitCents / 100;
            totalValue += unit * qty;
            trackingItems.push({
              item_id: String(foundV.id),
              item_name: 'ChillNeck ' + (foundP.title || ''),
              item_brand: 'ChillNeck',
              item_category: foundP.title || '',
              item_variant: foundV.label || foundV.size || '',
              price: +unit.toFixed(2),
              quantity: qty,
            });
          });
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'EUR',
              value: +totalValue.toFixed(2),
              items: trackingItems,
              bundle_size: currentRings.length,
            },
          });
        } catch (trackErr) { /* niemals den cart-flow blocken */ }

        // 220ms Delay, damit GTM den dataLayer-Push verarbeiten und Tags
        // via sendBeacon rausschicken kann bevor wir navigieren.
        // WICHTIG: locale-aware — window.Shopify.routes.root liefert "/", "/en/", "/es/".
        // Ohne diesen Prefix landen ES/EN-User auf der DE-Cart-Page → Checkout in DE!
        setTimeout(function(){
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          window.location.href = root + 'cart';
        }, 220);
      } catch (err) {
        bcSubmit.classList.remove('is-loading');
        bcSubmit.disabled = false;
        var Terr = (window.cnT && window.cnT.bundle) || {};
        bcSubmitLabel.textContent = Terr.errorRetry || 'Fehler — bitte erneut versuchen';
        console.error(err);
      }
    });
  }

  // Article: auto-TOC + scroll progress + share-copy
  var article = document.querySelector('[data-article]');
  if (article) {
    var body = article.querySelector('[data-article-body]');
    var tocList = article.querySelector('[data-toc-list]');
    var tocProgress = article.querySelector('[data-toc-progress]');
    var tocStatus = article.querySelector('[data-toc-status]');
    var headings = body ? body.querySelectorAll('h2, h3') : [];
    var tocItems = [];

    // Build TOC
    if (tocList && headings.length) {
      headings.forEach(function(h, i){
        if (!h.id) h.id = 'h-' + i + '-' + (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
        var li = document.createElement('li');
        li.textContent = h.textContent;
        li.dataset.targetId = h.id;
        if (h.tagName === 'H3') li.style.paddingLeft = '26px';
        tocList.appendChild(li);
        tocItems.push({ li: li, target: h });
      });
    } else if (tocList) {
      tocList.parentElement.style.display = 'none';
    }

    tocList && tocList.addEventListener('click', function(e){
      var li = e.target.closest('li[data-target-id]');
      if (!li) return;
      var el = document.getElementById(li.dataset.targetId);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // FAQ auto-interactive: H2 mit FAQ-Text → folgende H3+content in <details> umwandeln.
    // Erkennt: "FAQ", "Häufige Fragen", "Frequently Asked Questions", "Preguntas Frecuentes" etc.
    if (body) {
      var faqHeadingRegex = /^(faq|h[äa]ufige\s+fragen|frequently\s+asked\s+questions|preguntas\s+frecuentes|fragen\s+(&|und|y)\s+antworten)\b/i;
      var faqH2 = null;
      body.querySelectorAll('h2').forEach(function(h){
        if (!faqH2 && faqHeadingRegex.test((h.textContent || '').trim())) faqH2 = h;
      });
      if (faqH2) {
        // Sammle alle Siblings nach faqH2 bis zum nächsten H2 oder Ende
        var range = [];
        var sib = faqH2.nextElementSibling;
        while (sib && sib.tagName !== 'H2') {
          range.push(sib);
          sib = sib.nextElementSibling;
        }
        // Aus H3+ blocks Pärchen bauen: H3 ist Frage, alle nachfolgenden bis nächstem H3 sind Antwort.
        var items = [];
        var currentQ = null;
        var currentAnswer = [];
        range.forEach(function(el){
          if (el.tagName === 'H3') {
            if (currentQ) items.push({ q: currentQ, a: currentAnswer });
            currentQ = el;
            currentAnswer = [];
          } else if (currentQ) {
            currentAnswer.push(el);
          }
        });
        if (currentQ) items.push({ q: currentQ, a: currentAnswer });

        if (items.length > 0) {
          // Wrapper-Container erstellen
          var wrap = document.createElement('div');
          wrap.className = 'cn-article-faq';
          items.forEach(function(item, i){
            var d = document.createElement('details');
            if (i === 0) d.open = true; // erstes Item aufgeklappt für UX + Crawler-Hint
            var s = document.createElement('summary');
            s.textContent = item.q.textContent || '';
            d.appendChild(s);
            item.a.forEach(function(node){ d.appendChild(node.cloneNode(true)); });
            wrap.appendChild(d);
          });
          // Range im DOM ersetzen
          range.forEach(function(node){ node.remove(); });
          faqH2.parentNode.insertBefore(wrap, faqH2.nextSibling);
        }
      }
    }

    function onScroll(){
      // Reading progress
      var rect = article.getBoundingClientRect();
      var totalScroll = article.offsetHeight - window.innerHeight;
      var scrolled = Math.max(0, Math.min(1, -rect.top / Math.max(1, totalScroll)));
      var pct = Math.round(scrolled * 100);
      if (tocProgress) tocProgress.style.width = pct + '%';
      if (tocStatus) {
        var Tart = (window.cnT && window.cnT.article) || {};
        var tpl = Tart.readPercent || '__PCT__ % gelesen';
        tocStatus.textContent = tpl.replace('__PCT__', String(pct));
      }

      // Active TOC item: closest heading above viewport top + 80px
      var activeIdx = -1;
      for (var i = 0; i < tocItems.length; i++) {
        var top = tocItems[i].target.getBoundingClientRect().top;
        if (top < 100) activeIdx = i; else break;
      }
      tocItems.forEach(function(item, i){
        item.li.dataset.active = (i === activeIdx) ? 'true' : 'false';
      });
    }
    if (tocItems.length) {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Share: copy link
    article.addEventListener('click', function(e){
      var btn = e.target.closest('[data-share-copy]');
      if (!btn) return;
      var url = btn.getAttribute('data-share-url') || window.location.href;
      try {
        navigator.clipboard.writeText(url);
        var prev = btn.textContent;
        btn.textContent = '✓';
        setTimeout(function(){ btn.textContent = prev; }, 1500);
      } catch (err) { /* noop */ }
    });
  }

  // Hero Color Rotation (Pink ↔ Mint) + Sale Countdown
  (function(){
    var hero = document.querySelector('[data-hero-gallery]');
    if (hero) {
      var imgs = hero.querySelectorAll('[data-hero-img]');
      var labels = hero.querySelectorAll('[data-hero-label]');
      var dots = hero.querySelectorAll('[data-hero-color]');
      var imageLink = hero.querySelector('[data-hero-image-link]');
      var pinkUrl = hero.getAttribute('data-pink-url') || '/products/chillneck-pink-frost';
      var mintUrl = hero.getAttribute('data-mint-url') || '/products/chillneck-arctic-mint';
      // 4-State Rotation: Produkt-Shot → Lifestyle-Tragebild pro Farbe
      var states = ['pink', 'pink-neck', 'mint', 'mint-neck'];
      // Start auf dem Trage-Bild statt dem reinen Studio-Foto: Marc (Clarity-Feedback
      // 09.08.2026) bemaengelte, dass Mobile-Besucher im ersten Screen keine Person mit
      // ChillNeck sehen. Mint bleibt fuehrende Farbe (Duo-Bundle ist mint-verlinkt).
      var current = 'mint-neck';
      var autoTimer = null;
      var stopped = false;

      function colorOf(state) { return state.indexOf('mint') === 0 ? 'mint' : 'pink'; }

      function setState(state) {
        current = state;
        var color = colorOf(state);
        imgs.forEach(function(el){
          var match = el.getAttribute('data-hero-img') === state;
          el.classList.toggle('is-active', match);
          el.style.opacity = match ? '1' : '0';
        });
        labels.forEach(function(el){
          var match = el.getAttribute('data-hero-label') === color;
          el.classList.toggle('is-active', match);
          el.style.display = match ? '' : 'none';
        });
        dots.forEach(function(el){
          var match = el.getAttribute('data-hero-color') === color;
          el.classList.toggle('is-active', match);
          el.style.borderColor = match ? '#fff' : 'rgba(255,255,255,.5)';
        });
        if (imageLink) {
          imageLink.setAttribute('href', color === 'mint' ? mintUrl : pinkUrl);
        }
      }

      // Backward-Compat: alte Calls auf setColor(color) → setState mit Produkt-Variante
      function setColor(color) { setState(color); }

      function startAuto() {
        if (stopped) return;
        clearInterval(autoTimer);
        autoTimer = setInterval(function(){
          var idx = states.indexOf(current);
          var next = states[(idx + 1) % states.length];
          setState(next);
        }, 4000);
      }
      function stopAuto() {
        stopped = true;
        clearInterval(autoTimer);
      }

      dots.forEach(function(d){
        d.addEventListener('click', function(){
          stopAuto(); // user-interaction stops auto-rotation
          setState(d.getAttribute('data-hero-color')); // springt zur Produkt-Variante der Farbe
        });
      });

      hero.addEventListener('mouseenter', function(){ clearInterval(autoTimer); });
      hero.addEventListener('mouseleave', function(){ if (!stopped) startAuto(); });

      startAuto();
    }

  })();

  // Sticky Kaufleiste (Mobil): einblenden sobald der Hero-CTA nach oben aus dem
  // Bild gescrollt ist. Vorher gab es ab dem zweiten Screen keinen Kaufweg mehr,
  // nur den Warenkorb-FAB. Oberhalb 900px ist die Leiste per CSS aus.
  (function(){
    var bar = document.querySelector('[data-cn-buybar]');
    var anchor = document.querySelector('.cn-hero__text-body .cn-btn');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    function set(on) {
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('cn-buybar-on', on);
    }
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        // boundingClientRect.top < 0: nur wenn der CTA nach OBEN raus ist. Sonst
        // wuerde die Leiste auch erscheinen, solange der CTA noch unter dem Falz liegt.
        set(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(anchor);
  })();

  // Sale Countdown — generisch für ALLE [data-sale-countdown] Instanzen
  // (Hero, PDP-Preis, Bundles-Header, Cart-Summary …). Jede Instanz tickt
  // unabhängig, blendet bei Ablauf aus. Locale-Texte aus cnT.countdown.
  (function(){
    var nodes = document.querySelectorAll('[data-sale-countdown]');
    if (!nodes.length) return;
    var Tcd = (window.cnT && window.cnT.countdown) || {};
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    nodes.forEach(function(cd){
      var endStr = cd.getAttribute('data-end');
      var end = endStr ? new Date(endStr).getTime() : NaN;
      if (isNaN(end) || end <= Date.now()) return;
      var textEl = cd.querySelector('[data-countdown-text]');
      if (!textEl) return;
      function fmt() {
        var diff = end - Date.now();
        if (diff <= 0) { cd.setAttribute('hidden', ''); return false; }
        var days = Math.floor(diff / 86400000);
        var hrs = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        var parts = [];
        if (days > 0) parts.push(days + ' ' + (days === 1 ? (Tcd.daySingular || 'Tag') : (Tcd.dayPlural || 'Tagen')));
        parts.push(pad(hrs) + ':' + pad(mins) + ':' + pad(secs));
        textEl.textContent = parts.join(' ');
        return true;
      }
      if (fmt()) {
        cd.removeAttribute('hidden');
        setInterval(fmt, 1000);
      }
    });
  })();

  // Dynamic Heat Bar — IP-Geolocation + Open-Meteo Wetter-API mit Fallback-Kette
  (function(){
    var bar = document.querySelector('[data-heat-bar]');
    if (!bar || bar.getAttribute('data-mode') !== 'live') return;

    var minTemp = parseFloat(bar.getAttribute('data-min-temp') || '22');
    var cityEl = bar.querySelector('[data-heat-city]');
    var tempEl = bar.querySelector('[data-heat-temp]');
    var labelEl = bar.querySelector('[data-heat-label]');
    var suffixEl = bar.querySelector('[data-heat-suffix]');

    function setMessage(temp) {
      var T = (window.cnT && window.cnT.heat) || {};
      var label, suffix;
      if (temp >= 32)      { label = T.veryHotLabel  || 'Richtig heiß';   suffix = T.veryHotSuffix || 'Zeit für deinen Frische Boost'; }
      else if (temp >= 28) { label = T.hotLabel      || 'Heißer Tag';     suffix = T.hotSuffix     || 'ChillNeck umlegen, weiter chillen'; }
      else if (temp >= 24) { label = T.summerLabel   || 'Sommerlich';     suffix = T.summerSuffix  || 'perfekt für sanfte Frische am Nacken'; }
      else if (temp >= 20) { label = T.mildLabel     || 'Mild';           suffix = T.mildSuffix    || 'leichte Frische gefällig?'; }
      else if (temp >= 15) { label = T.springLabel   || 'Frühlingshaft';  suffix = T.springSuffix  || 'mach dich bereit für heiße Tage'; }
      else                 { label = T.waitingLabel  || 'Sommer kommt';   suffix = T.waitingSuffix || 'jetzt vorsorgen — ChillNeck holen'; }
      if (labelEl) labelEl.textContent = label;
      if (suffixEl) suffixEl.textContent = suffix;
    }

    var CACHE_KEY = 'cn-heat-bar-v5', CACHE_TTL = 30 * 60 * 1000;

    function showWith(city, temp) {
      if (typeof temp !== 'number') return;
      if (temp < minTemp) return; // unter Schwelle → bleibt komplett hidden
      if (cityEl && city) cityEl.textContent = city;
      if (tempEl) tempEl.textContent = Math.round(temp);
      setMessage(temp);
      bar.removeAttribute('hidden');
    }

    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        var data = JSON.parse(cached);
        if (Date.now() - data.t < CACHE_TTL && typeof data.temp === 'number') {
          showWith(data.city, data.temp);
          return;
        }
      }
    } catch (e) {}

    // IP-Service-Kette mit Fallback. Erste, die antwortet, gewinnt.
    function tryIpapi() {
      return fetch('https://ipapi.co/json/').then(function(r){
        if (!r.ok) throw new Error('ipapi-co');
        return r.json();
      }).then(function(d){
        return { lat: d.latitude, lng: d.longitude, city: d.city };
      });
    }
    function tryIpwhois() {
      return fetch('https://ipwho.is/').then(function(r){
        if (!r.ok) throw new Error('ipwhois');
        return r.json();
      }).then(function(d){
        if (!d.success) throw new Error('ipwhois-bad');
        return { lat: d.latitude, lng: d.longitude, city: d.city };
      });
    }
    function tryGeoJsIo() {
      return fetch('https://get.geojs.io/v1/ip/geo.json').then(function(r){
        if (!r.ok) throw new Error('geojs');
        return r.json();
      }).then(function(d){
        return { lat: parseFloat(d.latitude), lng: parseFloat(d.longitude), city: d.city };
      });
    }

    // ipwho.is zuerst — meist genauer für DE-IPs als ipapi.co (das oft auf Berlin-POPs routet)
    function getLocation() {
      return tryIpwhois()
        .catch(tryGeoJsIo)
        .catch(tryIpapi);
    }

    function fetchAndShow() {
      getLocation().then(function(loc){
        if (!loc || !loc.lat || !loc.lng) throw new Error('no coords');
        return fetch('https://api.open-meteo.com/v1/forecast?latitude=' + loc.lat + '&longitude=' + loc.lng + '&current=temperature_2m')
          .then(function(r){ if (!r.ok) throw new Error('weather'); return r.json(); })
          .then(function(w){
            var t = w.current && w.current.temperature_2m;
            if (typeof t !== 'number') throw new Error('no temp');
            try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ city: loc.city, temp: t, t: Date.now() })); } catch (e) {}
            showWith(loc.city, t);
          });
      }).catch(function(){ /* silently leave hidden */ });
    }

    if ('requestIdleCallback' in window) requestIdleCallback(fetchAndShow);
    else setTimeout(fetchAndShow, 200);
  })();

  // Google Consent Mode v2 — Brücke von Shopifys NATIVER Customer-Privacy-Banner (aktiv) zu gtag().
  // Bewusst UNABHÄNGIG vom folgenden custom-Banner-Block (der ist deaktiviert, siehe theme.liquid-
  // Kommentar "DSGVO-Cookie-Banner: Shopify-Native ist aktiv... Custom-Banner deaktiviert").
  (function () {
    function syncConsentToGoogle(analyticsAllowed, marketingAllowed) {
      if (typeof gtag !== 'function') return;
      gtag('consent', 'update', {
        analytics_storage: analyticsAllowed ? 'granted' : 'denied',
        ad_storage: marketingAllowed ? 'granted' : 'denied',
        ad_user_data: marketingAllowed ? 'granted' : 'denied',
        ad_personalization: marketingAllowed ? 'granted' : 'denied'
      });
    }
    // Beim Laden: tatsächlichen, bereits gespeicherten Consent-Stand übernehmen (nicht dauerhaft
    // auf "denied" stehen bleiben, wenn der Besucher schon früher zugestimmt hat).
    // Shopifys Privacy-API wird asynchron injiziert und ist bei theme.js-Start (trotz defer)
    // nicht garantiert schon verfügbar — daher kurzes Polling statt Einmal-Check.
    var privacyAttempts = 0;
    function trySyncInitialConsent() {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        try {
          syncConsentToGoogle(
            Shopify.customerPrivacy.analyticsProcessingAllowed(),
            Shopify.customerPrivacy.marketingAllowed()
          );
        } catch (e) {}
        return;
      }
      privacyAttempts++;
      if (privacyAttempts < 20) setTimeout(trySyncInitialConsent, 100);
    }
    trySyncInitialConsent();
    // Bei Änderung (Erstentscheidung oder späteres Anpassen über "Cookie-Einstellungen"):
    document.addEventListener('visitorConsentCollected', function (e) {
      var d = (e && e.detail) || {};
      syncConsentToGoogle(!!d.analyticsAllowed, !!d.marketingAllowed);
    });

    // "Cookie-Einstellungen"-Link im Footer: bisher gab es KEINE Möglichkeit, die native
    // Shopify-Banner nachträglich erneut zu öffnen. window.privacyBanner.showPreferences()
    // ist Shopifys offizielle, dokumentierte Methode dafür.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-open-privacy-preferences]');
      if (!btn) return;
      e.preventDefault();
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences().catch(function () {});
      }
    });
  })();

  // GA4 sign_up — nach erfolgreicher Kontoregistrierung. create_customer bietet
  // keinen Erfolgs-Hook im Theme; main-customer-register.liquid setzt daher
  // return_to auf ?signup=success, das hier ausgelesen und aus der URL entfernt wird.
  (function () {
    if (window.location.search.indexOf('signup=success') === -1) return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'sign_up', method: 'email' });
      var url = new URL(window.location.href);
      url.searchParams.delete('signup');
      window.history.replaceState({}, '', url.toString());
    } catch (signUpErr) {}
  })();

  // Cart v2: qty +/-, remove
  // ─────────────────────────────────────────────────────────────────────
  // Safari iOS-Fix (Mai 2026): cartForm.submit() triggert auf iOS-Safari
  // einen "Funktion laden"-Dialog der nie returnt. Stattdessen via
  // /cart/change.js JSON-API + location.reload() — funktioniert auf
  // allen Browsers inkl. iOS-Safari.
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var cartUpdating = false;
    function updateCartLine(line, quantity) {
      if (cartUpdating) return;
      cartUpdating = true;
      // Visuelles Feedback während Update
      cartForm.style.opacity = '0.6';
      cartForm.style.pointerEvents = 'none';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) })
      })
      .then(function(res){ return res.ok ? res.json() : Promise.reject(res); })
      .then(function(){ window.location.reload(); })
      .catch(function(err){
        cartUpdating = false;
        cartForm.style.opacity = '';
        cartForm.style.pointerEvents = '';
        console.error('Cart update failed:', err);
      });
    }

    cartForm.addEventListener('click', function(e){
      var qBtn = e.target.closest('[data-cart-qty]');
      if (qBtn) {
        e.preventDefault();
        var line = qBtn.getAttribute('data-line');
        var input = cartForm.querySelector('[data-line="' + line + '"][data-qty-input]');
        if (!input) return;
        var delta = parseInt(qBtn.getAttribute('data-cart-qty'), 10);
        var v = parseInt(input.value, 10) || 0;
        var newQty = Math.max(0, v + delta);
        input.value = newQty;
        updateCartLine(line, newQty);
        return;
      }
      var rmBtn = e.target.closest('[data-cart-remove]');
      if (rmBtn) {
        e.preventDefault();
        var rline = rmBtn.getAttribute('data-cart-remove');
        updateCartLine(rline, 0);
      }
    });

    // Manuelle Input-Änderung (Tastatur) → on blur/change auch via AJAX
    cartForm.addEventListener('change', function(e){
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var line = input.getAttribute('data-line');
      var newQty = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = newQty;
      updateCartLine(line, newQty);
    });

    // Form-Submit abfangen (für Enter-Press im Input) — auch via AJAX
    cartForm.addEventListener('submit', function(e){
      e.preventDefault();
      // Updates aller geänderten Inputs einsammeln
      var inputs = cartForm.querySelectorAll('[data-qty-input]');
      // Erste Änderung reicht — meist tippt User in 1 Input
      for (var i = 0; i < inputs.length; i++) {
        var line = inputs[i].getAttribute('data-line');
        var newQty = Math.max(0, parseInt(inputs[i].value, 10) || 0);
        updateCartLine(line, newQty);
        break;
      }
    });

    // begin_checkout wird direkt im inline-Script von main-cart.liquid beim
    // Klick auf den <a data-cn-checkout-link> gefeuert — kein Form-Submit mehr.

    // Rabattcode-Eingabe im Cart: über Shopify /discount/<code>?redirect=/cart
    // Cookie wird gesetzt, Discount-Code beim Checkout automatisch angewendet.
    var discountWrap = cartForm.querySelector('[data-cart-discount]');
    if (discountWrap) {
      var discountInput = discountWrap.querySelector('[data-discount-input]');
      var discountBtn = discountWrap.querySelector('[data-discount-apply]');
      var discountMsg = discountWrap.querySelector('[data-discount-msg]');
      var T = (window.cnT && window.cnT.cartDiscount) || {};
      function applyDiscount() {
        var code = (discountInput.value || '').trim().toUpperCase();
        if (!code) {
          discountMsg.hidden = false;
          discountMsg.className = 'cn-cart-v2__discount-msg is-error';
          discountMsg.textContent = T.empty || 'Bitte Code eingeben.';
          return;
        }
        discountBtn.disabled = true;
        discountBtn.textContent = T.applying || 'Wird angewendet …';
        // Locale-aware Cart-URL (z.B. /es/cart) als Redirect-Target — sonst landet ES-User auf DE-Cart
        var cartPath = window.location.pathname.replace(/[?#].*$/, '');
        var discountUrl = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartPath);
        window.location.href = discountUrl;
      }
      discountBtn.addEventListener('click', function(e){
        e.preventDefault();
        applyDiscount();
      });
      discountInput.addEventListener('keydown', function(e){
        if (e.key === 'Enter') {
          e.preventDefault();
          applyDiscount();
        }
      });
    }
  }

  // PDP v2: variant picker, gallery, qty
  var pdp = document.querySelector('[data-product-section]');
  if (pdp) {
    var variantsScript = pdp.querySelector('[data-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent || '[]'); } catch (e) {}
    var idInput = pdp.querySelector('[data-variant-id]');
    var qtyInput = pdp.querySelector('[data-qty-input]');
    var ctaPriceEls = pdp.querySelectorAll('[data-cta-price]');
    var priceEl = pdp.querySelector('[data-price]');
    var compareEl = pdp.querySelector('[data-compare]');
    var discountEl = pdp.querySelector('[data-discount]');
    var sizeLabel = pdp.querySelector('[data-size-label]');
    var themeSalePct = parseInt(pdp.getAttribute('data-cn-sale-pct') || '0', 10) || 0;

    function formatMoney(cents) {
      var euro = (cents / 100);
      return '€' + (euro % 1 === 0 ? euro.toFixed(0) : euro.toFixed(2).replace('.', ','));
    }

    // Echo der Server-Logic aus main-product.liquid:
    //   1) compare_at_price > price → Shopify-Sale
    //   2) sonst: settings.cn_sale_pct als Theme-weiter Aktionsrabatt
    function pricesFor(v) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var sp = v.compare_at_price - v.price;
        return { now: v.price, was: v.compare_at_price, pct: Math.round(sp * 100 / v.compare_at_price) };
      }
      if (themeSalePct > 0) {
        var off = Math.round(v.price * themeSalePct / 100);
        return { now: v.price - off, was: v.price, pct: themeSalePct };
      }
      return { now: v.price, was: null, pct: 0 };
    }
    function findVariant() {
      var selected = {};
      pdp.querySelectorAll('[data-option-input]:checked').forEach(function(input){
        var name = input.name.match(/options\[(.+)\]/);
        if (name) selected[name[1]] = input.value;
      });
      return variants.find(function(v){
        return v.options.every(function(val, i){
          var optName = (v.option1 && i === 0) ? null : null;
          return Object.keys(selected).some(function(key){ return selected[key] === val; });
        });
      }) || variants[0];
    }
    function updateCta() {
      var v = findVariant();
      if (!v) return;
      idInput.value = v.id;
      var qty = parseInt(qtyInput.value, 10) || 1;
      var p = pricesFor(v);
      ctaPriceEls.forEach(function(el){ el.textContent = formatMoney(p.now * qty); });
      if (priceEl) priceEl.textContent = formatMoney(p.now);
      if (p.was && p.was > p.now) {
        if (compareEl) {
          compareEl.textContent = formatMoney(p.was);
          compareEl.style.display = '';
        }
        if (discountEl) {
          discountEl.textContent = '−' + p.pct + ' %';
          discountEl.style.display = '';
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (discountEl) discountEl.style.display = 'none';
      }
    }

    // PDP Add-to-Cart via fetch /cart/add.js statt native form-submit.
    // Begründung: Native Form-Submit triggert zwar Shopifys product_added_to_cart
    // Customer Event, aber der Browser navigiert sofort weg — das sandboxed
    // addingwell-pixel-Iframe verarbeitet den Event evtl. nicht rechtzeitig.
    // fetch /cart/add.js feuert das Customer Event synchron im aktuellen Tab
    // und gibt Pixel-Sandbox + GTM Zeit, ihre Tags via sendBeacon abzusetzen,
    // bevor wir kontrolliert nach /cart navigieren.
    var pdpForm = pdp.querySelector('form[action*="/cart/add"]');
    var pdpSubmitBtn = pdpForm ? pdpForm.querySelector('[data-add-to-cart]') : null;
    if (pdpForm) {
      pdpForm.addEventListener('submit', async function(e){
        e.preventDefault();

        var v = findVariant();
        if (!v) return;
        var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;

        if (pdpSubmitBtn) {
          pdpSubmitBtn.classList.add('is-loading');
          pdpSubmitBtn.disabled = true;
        }

        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: v.id, quantity: qty }),
          });
          if (!res.ok) throw new Error('cart/add failed: ' + res.status);

          // dataLayer push für browser-side GTM (parallel zu Shopifys
          // product_added_to_cart Customer Event, das das addingwell-pixel
          // separat empfängt).
          try {
            var p = pricesFor(v);
            var unit = (p.now || 0) / 100;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              event: 'add_to_cart',
              ecommerce: {
                currency: pdp.getAttribute('data-currency') || 'EUR',
                value: +(unit * qty).toFixed(2),
                items: [{
                  item_id: String(v.id),
                  item_name: pdp.getAttribute('data-product-title') || '',
                  item_brand: pdp.getAttribute('data-product-vendor') || 'ChillNeck',
                  item_category: pdp.getAttribute('data-product-type') || '',
                  item_variant: v.title || (v.options || []).join(' / '),
                  price: +unit.toFixed(2),
                  quantity: qty,
                  product_id: pdp.getAttribute('data-product-id') || '',
                }],
              },
            });
          } catch (trackErr) { /* tracking darf cart-add nie blocken */ }

          // 220ms Delay damit GTM-Tags + Pixel-Sandbox-Events via sendBeacon
          // sicher rausgehen bevor Browser navigiert (identisches Pattern wie Bundle).
          // Locale-aware: ES/EN-User landen sonst auf /cart (DE) statt /es/cart bzw. /en/cart.
          setTimeout(function(){
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            window.location.href = root + 'cart';
          }, 220);
        } catch (err) {
          if (pdpSubmitBtn) {
            pdpSubmitBtn.classList.remove('is-loading');
            pdpSubmitBtn.disabled = false;
          }
          console.error('PDP cart/add failed:', err);
        }
      });
    }

    // Sticky mobile Add-to-Cart bar: erscheint sobald der Haupt-CTA-Button
    // aus dem Viewport gescrollt ist. Klick proxied auf den echten Submit-
    // Button, damit cart/add.js + dataLayer-Logik oben unveraendert greift.
    var stickyAtc = document.querySelector('[data-sticky-atc]');
    if (stickyAtc && pdpSubmitBtn && 'IntersectionObserver' in window) {
      var stickyBtn = stickyAtc.querySelector('[data-sticky-add-to-cart]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function(){
          pdpSubmitBtn.click();
        });
      }
      var atcObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            stickyAtc.removeAttribute('data-visible');
          } else {
            stickyAtc.setAttribute('data-visible', '');
          }
        });
      }, { threshold: 0 });
      atcObserver.observe(pdpSubmitBtn);
    }

    // Size pill toggle
    pdp.addEventListener('change', function(e){
      var input = e.target.closest('[data-option-input]');
      if (!input) return;
      var label = input.closest('.cn-pdp-v2__size');
      if (label) {
        pdp.querySelectorAll('.cn-pdp-v2__size').forEach(function(l){ l.classList.remove('is-selected'); });
        label.classList.add('is-selected');
      }
      if (sizeLabel) {
        var letter = label && label.querySelector('.cn-pdp-v2__size-letter');
        if (letter) sizeLabel.textContent = letter.textContent;
      }
      updateCta();
    });

    // Größenfinder-Übernahme: ?cn_size=S|M|L aus URL → empfohlene Größe vorauswählen.
    // Feuert den Change-Handler oben → is-selected + Label + Varianten-ID + Preis
    // werden gesetzt; Add-to-Cart nutzt damit automatisch die richtige Variante.
    (function(){
      var want = (new URLSearchParams(window.location.search).get('cn_size') || '').trim().toUpperCase();
      if (!want) return;
      var labels = pdp.querySelectorAll('.cn-pdp-v2__size');
      for (var i = 0; i < labels.length; i++) {
        var letterEl = labels[i].querySelector('.cn-pdp-v2__size-letter');
        var input = labels[i].querySelector('[data-option-input]');
        if (letterEl && input && letterEl.textContent.trim().toUpperCase() === want) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    })();

    // Quantity buttons
    pdp.addEventListener('click', function(e){
      var qBtn = e.target.closest('[data-qty]');
      if (qBtn) {
        var delta = parseInt(qBtn.getAttribute('data-qty'), 10);
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v + delta);
        updateCta();
        return;
      }
      var thumb = e.target.closest('[data-thumb-idx]');
      if (thumb) {
        var idx = thumb.getAttribute('data-thumb-idx');
        pdp.querySelectorAll('[data-thumb-idx]').forEach(function(t){ t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        pdp.querySelectorAll('[data-img-idx]').forEach(function(img){
          img.classList.toggle('is-active', img.getAttribute('data-img-idx') === idx);
        });
      }
    });

    // Beweglicher Zoom auf dem Hauptbild. Desktop: Hover zoomt automatisch rein und
    // folgt der Mausposition. Mobil: Tap zoomt rein, Ziehen waehrend gezoomt pannt,
    // ein weiterer Tap ohne Ziehen zoomt wieder raus. Ersetzt den fruaheren Hover/
    // Tap-zu-Lifestyle-Foto-Ansatz vom 19.08.2026: das Zweitbild war ja ohnehin schon
    // per Thumbnail erreichbar, ein Zoom liefert dagegen echten Zusatznutzen (Naehte,
    // Material, Details naeher ansehen).
    var cnStage = pdp.querySelector('.cn-pdp-v2__stage[data-zoomable]');
    if (cnStage) {
      var cnHoverCapable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      function cnSetZoomPoint(clientX, clientY) {
        var rect = cnStage.getBoundingClientRect();
        var x = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        var y = Math.min(100, Math.max(0, ((clientY - rect.top) / rect.height) * 100));
        cnStage.style.setProperty('--cn-zoom-x', x + '%');
        cnStage.style.setProperty('--cn-zoom-y', y + '%');
      }
      function cnZoomIn(clientX, clientY) {
        cnSetZoomPoint(clientX, clientY);
        cnStage.classList.add('is-zoomed');
      }
      function cnZoomOut() {
        cnStage.classList.remove('is-zoomed');
      }

      if (cnHoverCapable) {
        cnStage.addEventListener('mouseenter', function (e) { cnZoomIn(e.clientX, e.clientY); });
        cnStage.addEventListener('mousemove', function (e) { cnSetZoomPoint(e.clientX, e.clientY); });
        cnStage.addEventListener('mouseleave', cnZoomOut);
      } else {
        // Tap statt Touchstart (Tim, 20.08.2026): vorher zoomte schon das reine
        // Beruehren rein, das kaperte jeden Scroll-Versuch, der zufaellig auf dem
        // Bild startete. Jetzt: touchstart merkt sich nur Position/Zeit, erst
        // touchend entscheidet. Ohne Bewegung = Tap = zoomt rein (nicht-gezoomt)
        // bzw. wieder raus (gezoomt). Mit Bewegung im nicht-gezoomten Zustand wird
        // NIE preventDefault aufgerufen, die Seite scrollt normal weiter. Im
        // gezoomten Zustand pannt Ziehen (preventDefault, sonst scrollt die Seite
        // mit); ein SCHNELLES Wischen zaehlt zusaetzlich als Verlassen-Geste,
        // langsames Ziehen bleibt beim Betrachten.
        var TAP_MAX_MOVE = 10;
        var SWIPE_SPEED = 0.6; // px/ms
        var cnStartX = 0, cnStartY = 0, cnStartTime = 0;
        var cnLastX = 0, cnLastY = 0, cnLastTime = 0;
        var cnMoved = false;

        cnStage.addEventListener('touchstart', function (e) {
          if (e.target.closest('.cn-pdp-v2__badge')) return;
          var t = e.touches[0];
          cnStartX = cnLastX = t.clientX;
          cnStartY = cnLastY = t.clientY;
          cnStartTime = cnLastTime = Date.now();
          cnMoved = false;
          if (cnStage.classList.contains('is-zoomed')) {
            cnSetZoomPoint(t.clientX, t.clientY);
          }
        }, { passive: true });

        cnStage.addEventListener('touchmove', function (e) {
          var t = e.touches[0];
          if (Math.abs(t.clientX - cnStartX) > TAP_MAX_MOVE || Math.abs(t.clientY - cnStartY) > TAP_MAX_MOVE) {
            cnMoved = true;
          }
          if (cnStage.classList.contains('is-zoomed')) {
            cnSetZoomPoint(t.clientX, t.clientY);
            e.preventDefault();
          }
          cnLastX = t.clientX;
          cnLastY = t.clientY;
          cnLastTime = Date.now();
        }, { passive: false });

        cnStage.addEventListener('touchend', function () {
          var wasZoomed = cnStage.classList.contains('is-zoomed');
          if (!wasZoomed) {
            if (!cnMoved) cnZoomIn(cnStartX, cnStartY);
            return;
          }
          if (!cnMoved) { cnZoomOut(); return; }
          var dist = Math.hypot(cnLastX - cnStartX, cnLastY - cnStartY);
          var speed = dist / Math.max(1, cnLastTime - cnStartTime);
          if (speed > SWIPE_SPEED) cnZoomOut();
        });
      }
    }

    qtyInput && qtyInput.addEventListener('input', updateCta);

    updateCta();
  }

  // Color/size variant pickers (product page)
  var picker = document.querySelector('[data-variant-picker]');
  if (picker) {
    picker.addEventListener('click', function(e){
      var opt = e.target.closest('[data-variant-option]');
      if (!opt) return;
      var group = opt.getAttribute('data-variant-group');
      picker.querySelectorAll('[data-variant-group="'+group+'"]').forEach(function(b){ b.classList.remove('is-selected'); });
      opt.classList.add('is-selected');
    });
  }
})();

// Video-Feature: Click-to-Load YouTube. Lädt erst nach Klick (Privacy/Consent) und
// über youtube-nocookie.com. Delegiert -> funktioniert bei mehrfacher Verwendung.
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-cn-video-play]');
    if (!btn) return;
    var id = btn.getAttribute('data-cn-video-id');
    if (!id) return;
    var wrap = btn.closest('.cn-video-embed');
    if (!wrap) return;
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
    iframe.title = btn.getAttribute('aria-label') || 'Video';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', '');
    wrap.innerHTML = '';
    wrap.appendChild(iframe);
  });
})();

// Attribution-Sicherungsnetz: Herkunft der Sitzung festhalten und als Warenkorb-
// Attribute an die Bestellung haengen.
//
// Warum: Auf der Checkout-Seite laeuft weder unser GTM noch der dataLayer, und die
// Shopify-Web-Pixel arbeiten in einem Sandbox-iframe ohne allow-same-origin. Reisst
// dort die Cookie-Kette, landet der Kauf in GA4 als (direct). Die Warenkorb-Attribute
// gehen diesen Weg nicht mit, sie haengen serverseitig an der Bestellung und sind im
// Shopify-Admin unter "Weitere Details" sichtbar. Damit ist die echte Quelle auch dann
// belegt, wenn GA4 sie verliert.
//
// Bewusst NICHT in die Add-to-Cart-Pfade eingehaengt: das Tracking laeuft, und ein
// Fehler dort wuerde den Kaufweg treffen. Geschrieben wird nur nebenlaeufig und
// ausschliesslich, wenn bereits ein Warenkorb mit Artikeln existiert.
(function () {
  var KEY = 'cn_attr';
  var KEY_DONE = 'cn_attr_written';
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid'];

  // Erstberuehrung ueberdauert die Sitzung, deshalb localStorage statt sessionStorage.
  // Begruendung aus der Auswertung vom 15.08.2026: von den Bestellungen, bei denen
  // Shopify "direkt" als letzte Beruehrung meldet, hatten 42 % vorher eine andere
  // Quelle, praktisch immer Google, mit bis zu 12 Beruehrungen und 20 Tagen Abstand.
  // Der Kanalbericht ist reine Last-Touch-Zuordnung und verbucht diese Kaeufe als
  // Direkt. Mit der Erstberuehrung laesst sich das gegenrechnen.
  var FIRST_KEY = 'cn_attr_first';
  // 30 Tage, aus den eigenen Daten abgeleitet (100 Bestellungen, 15.08.2026):
  // 60 % kaufen binnen 1 Tag, 92 % binnen 14 Tagen, 100 % binnen 30 Tagen, laengste
  // Strecke 25 Tage. Ein laengeres Fenster wuerde nur Beruehrungen gutschreiben, die
  // nachweislich niemand mehr braucht, und den Datenbestand unnoetig verlaengern.
  var FIRST_TTL_MS = 30 * 24 * 60 * 60 * 1000;

  function gespeichert(k) {
    try { return sessionStorage.getItem(k); } catch (e) { return null; }
  }
  function speichern(k, v) {
    try { sessionStorage.setItem(k, v); } catch (e) {}
  }
  function dauerhaftLesen(k) {
    try { return localStorage.getItem(k); } catch (e) { return null; }
  }
  function dauerhaftSchreiben(k, v) {
    try { localStorage.setItem(k, v); } catch (e) {}
  }

  // Die allererste bekannte Herkunft, hoechstens 90 Tage alt. Wird genau einmal
  // gesetzt und danach nie ueberschrieben, auch nicht von einer spaeteren Kampagne.
  // Ein leerer Datensatz ist ein gueltiges Ergebnis und bedeutet echt direkt.
  function erstberuehrung(aktuell) {
    var roh = dauerhaftLesen(FIRST_KEY);
    if (roh) {
      try {
        var alt = JSON.parse(roh);
        if (alt && alt.ts && (Date.now() - alt.ts) < FIRST_TTL_MS) return alt;
      } catch (e) {}
    }
    var neu = { d: aktuell || {}, ts: Date.now() };
    dauerhaftSchreiben(FIRST_KEY, JSON.stringify(neu));
    return neu;
  }

  // Erste Seite der Sitzung gewinnt. Spaetere interne Seitenaufrufe duerfen die
  // Quelle nicht ueberschreiben, sonst wird aus jeder Kampagne am Ende (direct).
  function erfassen() {
    var vorhanden = gespeichert(KEY);
    if (vorhanden) {
      try { return JSON.parse(vorhanden); } catch (e) {}
    }
    var daten = {};
    try {
      var q = new URLSearchParams(window.location.search);
      UTM.forEach(function (p) {
        var v = q.get(p);
        if (v) daten[p] = String(v).slice(0, 100);
      });
      for (var i = 0; i < CLICK_IDS.length; i++) {
        var cv = q.get(CLICK_IDS[i]);
        if (cv) { daten.click = CLICK_IDS[i] + ':' + String(cv).slice(0, 120); break; }
      }
      var ref = document.referrer || '';
      if (ref && ref.indexOf(window.location.host) === -1) daten.referrer = ref.slice(0, 150);
      daten.landing = (window.location.pathname || '/').slice(0, 150);
    } catch (e) {}
    try { speichern(KEY, JSON.stringify(daten)); } catch (e) {}
    return daten;
  }

  var attr = erfassen();
  var erst = erstberuehrung(attr);

  // Wie viele Sitzungen bis zum Kauf. Shopify liefert das als momentsCount, aber nur
  // bei knapp der Haelfte der Bestellungen, weil es an der Einwilligung haengt. Diese
  // Zaehlung laeuft unabhaengig davon und zeigt, ob jemand sofort kauft oder wiederkommt.
  var BESUCH_KEY = 'cn_attr_visits';
  var BESUCH_SESSION = 'cn_attr_counted';
  function besucheZaehlen() {
    var n = parseInt(dauerhaftLesen(BESUCH_KEY) || '0', 10) || 0;
    if (gespeichert(BESUCH_SESSION) !== '1') {
      n += 1;
      dauerhaftSchreiben(BESUCH_KEY, String(n));
      speichern(BESUCH_SESSION, '1');
    }
    return n;
  }
  var besuche = besucheZaehlen();

  function attribute() {
    var e = erst.d || {};
    var tage = Math.round((Date.now() - erst.ts) / 86400000);
    return {
      // Letzte Beruehrung, also die Sitzung, in der gekauft wurde
      cn_source: attr.utm_source || '',
      cn_medium: attr.utm_medium || '',
      cn_campaign: attr.utm_campaign || '',
      // Motiv und Suchbegriff wurden bisher erfasst und dann verworfen. Genau dort
      // steht aber, WELCHE Anzeige gewirkt hat, nicht nur welche Kampagne.
      cn_content: attr.utm_content || '',
      cn_term: attr.utm_term || '',
      cn_clickid: attr.click || '',
      cn_referrer: attr.referrer || '',
      cn_landing: attr.landing || '',
      // Erste bekannte Beruehrung, ueberdauert Sitzungen. Leer heisst echt direkt.
      cn_first_source: e.utm_source || '',
      cn_first_medium: e.utm_medium || '',
      cn_first_campaign: e.utm_campaign || '',
      cn_first_content: e.utm_content || '',
      cn_first_term: e.utm_term || '',
      cn_first_referrer: e.referrer || '',
      cn_first_landing: e.landing || '',
      // Ohne die Klick-ID laesst sich bezahlter Google-Traffic nicht von organischem
      // trennen, solange die Anzeigen keine UTM-Parameter tragen. Genau dieser Fall
      // liegt aktuell vor: alle 29 gemessenen Google-Erstberuehrungen hatten keine UTM.
      cn_first_click: e.click || '',
      cn_first_days: String(tage),
      cn_visits: String(besuche)
    };
  }

  function schreiben(mitKeepalive) {
    if (gespeichert(KEY_DONE) === '1') return;
    speichern(KEY_DONE, '1'); // vorab setzen, damit ein Klick nicht doppelt sendet
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attribute() }),
        keepalive: !!mitKeepalive
      })['catch'](function () { speichern(KEY_DONE, ''); });
    } catch (e) { speichern(KEY_DONE, ''); }
  }

  // 1) Nebenlaeufig: nur schreiben, wenn schon ein Warenkorb mit Artikeln existiert.
  //    Verhindert, dass fuer jeden Besucher ohne Kaufabsicht ein Warenkorb entsteht.
  function pruefenUndSchreiben() {
    if (gespeichert(KEY_DONE) === '1') return;
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.item_count > 0) schreiben(false); })
        ['catch'](function () {});
    } catch (e) {}
  }
  if (window.requestIdleCallback) {
    requestIdleCallback(pruefenUndSchreiben, { timeout: 4000 });
  } else {
    setTimeout(pruefenUndSchreiben, 2500);
  }

  // 2) Sicherheitsnetz fuer den Fall, dass jemand direkt aus einem Drawer zur Kasse
  //    geht, ohne vorher eine Seite zu wechseln. keepalive haelt den Request am Leben,
  //    obwohl die Navigation schon laeuft.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], button[href*="/checkout"]');
    if (t) schreiben(true);
  }, true);
})();
